import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.section`
  width: 100%;
  background-color: ${({ theme }) => theme.backgrounds.modal};
  border: ${({ theme }) => `1px solid ${theme.backgrounds.tableItem}`};
  border-radius: 4px;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 36px;
  min-height: 68px;
`;

export const StepBadge = styled.div`
  min-width: 24px;
  height: 24px;
  border-radius: 5px;
  background-color: ${colors.blue9};
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const Divider = styled.div`
  width: 100%;
  border-top: ${({ theme }) => `2px solid ${theme.backgrounds.tableItem}`};
`;

export const Body = styled.div`
  padding: 36px;
`;
